import React, {PureComponent} from 'react'
// import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Icon from '../../Icon'
import Arrow from '../../Arrow'
import {dateToFormatter} from '../../../formatters/date'


export default class UslugaItem extends PureComponent {
  // static propTypes = {
  //   data: PropTypes.shape().isRequired
  // }
  
  render() {
    const {data} = this.props
    return (
      <li className={`dashboard__item background-color--${data.style}`}>
        <Link to={`/uslugas/${data.id}`} className="dashboard__item-link">
          <div className="dashboard__col-icon">
            <Icon type={data.category_id} />
          </div>
          <div className="dashboard__col-name-wrapper">
            <div className="dashboard__col-uslugaName">
              <p>{data.passportName}</p>
            </div>
            <div className="dashboard__col-organizationName">
              <p>{data.organizationName}</p>
            </div>
          </div>
          <div className="dashboard__col-date">
            <span>{dateToFormatter(data.expires_at)}</span>
          </div>
          <Arrow />
        </Link>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./components/DashboardExecutor/List/UslugaItem.jsx